import styled from 'styled-components';

export const OpName = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 2px;
`;

export const Section = styled.div`
  margin-bottom: 8px;
`;

export const Subheader = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 2px;
`;

export const Markdown = styled.div`
  font-size: 14px;
`;

export const ArgList = styled.ul`
  margin: 0;
  list-style-type: none;
  padding-left: 16px;

  li {
    margin-bottom: 4px;
    line-height: 1em;
  }
`;

export const ArgName = styled.span`
  font-size: 14px;
  font-weight: 600;
`;
